<template>
  <div class="card-content details">
    <div class="is-pulled-left">
      <logo-agence
        v-if="(logoParAgence || factureDetail.regleFacturationId) && logo"
        :logo="logo">
      </logo-agence>
      <logo-societe v-else :societeId="!isSensAchat
          ? factureDetail.societeId  : facture.destinataire.tiersId"></logo-societe>
    </div>
    <div class="reference">
      <strong>{{ facture.generalInfos.titleType  }} {{ factureDetail.code }}</strong>
      <p>{{ facture.generalInfos.theme }}</p>
      <span>{{ facture.generalInfos.dateDevisCommande }}</span>
      <div class="is-size-6 mgt-20px" v-if="!isSensAchat
          && facture.typeReferenceExterne !== constantes.REFERENCE_EXTERNE_CONTRAT">
        {{ getlibelleToDisplay + ' ' + facture.generalInfos.datePremierAffichage}}
      </div>
      <div class="is-size-6"  v-if="facture.generalInfos.campagneId && moduleCampagneActive">
        {{ $t('detail.generalInfos.campagne') }}
        <router-link-blank
          :message="facture.generalInfos.campagneLibelle"
          :to="{
            name: 'c.bodac.campagne',
            params: { id: facture.generalInfos.campagneId },
          }"
          class-message="lien">
        </router-link-blank>
      </div>
      <div class="is-size-6" v-if="!isFactureBailleur && !isSensAchat">
        {{ $t('detail.generalInfos.categorieVente') }}
        {{ $t(facture.generalInfos.categorieVente) }}
      </div>
      <div class="is-size-6" v-if="modulePresseActive && factureDetail.regleFacturationId">
        {{ $t('detail.generalInfos.regleFacturation') }}
        {{ getLibelleRegleFacturation(factureDetail.regleFacturationId) }}
      </div>
      <div class="is-size-6" v-if="facture.generalInfos.commission && !isPrevisualisation">
        {{ $t('detail.generalInfos.commission') }}
        {{ facture.generalInfos.commission | formatPercent}}
      </div>
    </div>
    <div class="intervenant is-flex"
         :class="{'is-spaced-between': commercial}">
      <div>
        <div v-if="isSensAchat && facture.referenceClient !== null">
          {{ $t('detailDepenseBailleur.referenceFournisseur',
          { referenceFournisseur: facture.referenceClient }) }}
        </div>
        <infos-commercial v-if="commercial"
                          :commercial="commercial"
                          :reference-client="facture.referenceClient"
                          :code-dossier="facture.codeDossier"/>
        <div v-if="facture.destinataireComptable && facture.destinataireComptable.compteComptable">
          {{
            `${$t('detail.compteComptable')} : ${facture.destinataireComptable.compteComptable}`
          }}
        </div>
        <div>
           {{ $t('detailFacture.categorieOperation',
             { categorieOperation: getCatgorieOperation } )}}</div>
      </div>
      <div class="has-text-right"
           :class="{'pull-right': !commercial}">
        <div v-if="mentionMandataire">
          {{ facture.destinataire.titre ? facture.destinataire.titre
          : facture.destinataire.libelle }}
        </div>
        <div class="columns is-marginless">
          <div class="column is-paddingless"></div>
          <div class="column is-narrow is-paddingless">
            <b-tooltip :label="$t('detailFacture.clients.clientExonerationTva')"
                       v-if="facture.destinataire && facture.destinataire.annonceur
                       && func.getExonerationTva(facture.destinataire)"
                       type="is-warning"
                       position="is-left">
              <b-icon icon="earth-arrow-right" class="is-cursor-pointer mgr-5px"
                      size="is-small"
                      type="is-warning">
              </b-icon>
            </b-tooltip>
            <b-tooltip :label="$t('detailFacture.clients.prospect')"
                       v-if="facture.destinataire && facture.destinataire.tiers
                       && facture.destinataire.tiers.prospect"
                       type="is-warning"
                       position="is-left">
              <b-icon icon="account-search" class="is-cursor-pointer mgr-5px"
                      size="is-small"
                      type="is-warning">
              </b-icon>
            </b-tooltip>
          </div>
          <router-link-blank
              v-if="activeButtonEtLien"
              class="column is-narrow is-paddingless"
              v-bind="routeTiers"/>
          <span v-else>{{
            facture.destinataire.adressePostale.intitule1
            ? facture.destinataire.adressePostale.intitule1
            : facture.destinataire.nomCommercial }}</span>
        </div>
        <div v-if="!isBonReception">
          {{ facture.destinataire.adressePostale.intitule2 }}
          <span v-if="mentionMandataire">
                {{ facture.destinataire.adressePostale.intitule3 }}
              </span>
        </div>
        <div v-if="!mentionMandataire && !isBonReception">
          {{ facture.destinataire.adressePostale.intitule3 }}
        </div>
        <div  v-if="!isBonReception">
          {{ facture.destinataire.adressePostale.adresse1 }}
        </div>
        <div v-if="!isBonReception">
          {{ facture.destinataire.adressePostale.adresse2 }}
        </div>
        <div v-if="!isBonReception">
          {{ facture.destinataire.adressePostale.adresse3 }}
        </div>
        <div v-if="!isBonReception">
          <span v-if="facture.destinataire.adressePostale.codePostal">
          {{ $t('detail.codePostal', {
            codePostal: facture.destinataire.adressePostale.codePostal}) }}
          </span>
          {{ facture.destinataire.adressePostale.ville }}</div>
        <div v-if="!isBonReception"> {{ facture.destinataire.adressePostale.pays }}</div>
        <div v-if="canDisplayDestinataireComptableLabel">
          {{ $t('detail.commande.intervenant.destinataireComptableLabel') }}
        </div>
        <div v-if="facture.destinataire">
          <div v-if="tvaIntracommunautaireVisible">
            {{ $t('detail.commande.intervenant.tvaIntracommunautaire',
            { val: tvaIntracommunautaireValue }) }}
          </div>
          <span v-if="siretVisible">
            {{ siretLabel }}
          </span>
          <multi-contact-intervenant :intervenant="facture.destinataire"/>
        </div>
      </div>
    </div>
    <infos-intervenant v-if="facture.intervenants"
                       :intervenants="facture.intervenants"
                       :afficherLien="activeButtonEtLien"
                       :dcf="factureDetail"/>
    <br>
    <small v-if="isCommandeAchatFournisseur && commandeVenteCode">
      <router-link-blank
        :to="{
          name: 'c.bodac.commandes',
          params: {
            id: factureDetail.referenceExterne
          }
        }"
        :message="$t('detailFacture.commandeVente', { code: commandeVenteCode } )"
      />
    </small>
    <small v-if="facture.reference">
      <router-link-blank v-if="factureDetail.sousType !== constantes.SOUS_TYPE_AVOIR
          && factureDetail.sousType !== constantes.SOUS_TYPE_AVOIR_SUR_ACOMPTE
          && facture.generalInfos.routerLinkName"
                         :to="{ name: facture.generalInfos.routerLinkName,
                           params: {id: facture.reference.id}}"
                         :message="$t(facture.generalInfos.routerLink, {
                number: facture.reference.code,
                date: facture.reference.dateDevisCommande
                })"/>
      <router-link-blank v-else-if="facture.generalInfos.routerLink"
                         :to="{name: getFactureRoute,
                         params: {id: facture.reference.id}}"
                         :message="$t(facture.generalInfos.routerLink)
                         + facture.reference.code"
      />
    </small>
    <small v-if="factureDetail.planMediaId && modulePlanMediaActive">
      <router-link-blank
        :to="{name: 'c.presse.plan_media', params: {id: factureDetail.planMediaId}}"
        :message="$t('detail.commande.planMediaReference',
        { numero: factureDetail.planMedia.code })"/>
    </small>
    <small v-if="isFactureBailleur">
      <router-link-blank :to="{name: 'c.baux.contrat',
                         params: {id: factureDetail.referenceExterne }}"
                         v-if="isFactureAvoir || isFactureAnnule"
                         :message="$t('detail.commande.referenceContrat',
                             { codeDossier: factureDetail.codeDossier })"
      />
      <router-link-blank :to="{name: 'c.baux.contrat-facture-in-echeancier',
                         params: {id: factureDetail.referenceExterne,
                         idCommandeAchat: facture.reference.id }}"
                         v-if="isFactureNormal && facture.reference"
                         :message="$t('detail.commande.referenceVersEcheancier',
                             { bail: factureDetail.codeDossier })"
      />
    </small>
    <small v-if="isAnnulationPaiement">
      <router-link-blank
        :to="{name: 'c.bodac.remises_bancaires', params: {id: remiseBancaireId }}"
        :message="$t('detail.commande.referenceVersRemiseBancaire')"/>
    </small>
    <detail-lignes-commande
      :referencesCommandes="factureDetail.references"
      :masqueRemise="factureDetail.masqueRemise"
      :isEditPrevisu="isEditPrevisu"
      :isPrevisualisation="isPrevisualisation"
      :typeDCF="constantes.TYPE_FACTURE"
      :sens="factureDetail.sens"
      :lignes-commande="facture.lignesCommande"
      :afficherLien="activeButtonEtLien"
      @masqueLigneChange="$emit('masqueLigneChange', $event)"
      @masqueRemiseChange="$emit('masqueRemiseChange', $event)"/>
    <div class="summary-container">
      <div class="column is-4 is-paddingless">
        <repartitions-tva
          v-if="factureDetail.montantTva !== 0"
          :repartitions-tva="facture.repartitionsTva"/>
        <br>
        <acomptes-affectes :facturesAcompte="facture.acomptesAffectes"
                           v-if="facture.acomptesAffectes.length > 0">
        </acomptes-affectes>
        <template v-if="facture.tauxPenalite && !isSensAchat">
          <small>
            {{ $t('detail.conditions.tauxPenalite') }}
            &nbsp;{{ facture.tauxPenalite }} %
          </small>
          <br>
        </template>
        <br>
        <template v-if="facture.penalite && !isSensAchat">
          <div v-if="factureDetail.textPenalite.length > 0"
            v-html="factureDetail.textPenalite"></div>
          <small v-else>{{ $t('detail.conditions.penalite') }}</small>
          <br><br>
        </template>
        <template v-if="factureDetail.recouvrement && !isSensAchat">
          <small>
            <span>{{ $t('detail.conditions.recouvrement') }}</span>
          </small>
          <br><br>
        </template>
        <template v-if="facture.tauxEscompte && !isSensAchat">
          <small>{{ $t('detail.conditions.tauxEscompte') }}
            &nbsp;{{ facture.tauxEscompte }} %</small>
          <br><br>
        </template>
        <template v-if="facture.escompte && !isSensAchat">
          <small>{{ $t('detail.conditions.escompte') }}</small>
          <br><br>
        </template>
      </div>
      <div class="column is-paddingless">
        <div class="column is-6 is-paddingless pull-right">
          <recapitulatif-montants
            :recapitulatif="facture.recapitulatifMontants"/>
        </div>
        <div class="column is-offset-4">
          <template v-if="facture.commentaire">
            <div>
              <strong>{{ $t('detail.conditions.commentaires') }}</strong>
            </div>
            <br>
            <small v-html="facture.commentaire" class="is-prewrap"></small>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import RecapitulatifMontants from '@/components/devisCommandes/detailDevisCommande/recapitulatifMontants';
import {
  SENS_ACHAT, REFERENCE_EXTERNE_CONTRAT, TYPE_FACTURE,
  SOUS_TYPE_AVOIR, SOUS_TYPE_NORMAL, ETAT_ANNULER,
  REFERENCE_EXTERNE_ANNULATION_REGLEMENT as ANNULATION_REGLEMENT,
  SENS_VENTE, TYPE_COMMANDE, MODULE_ACHAT, SOUS_TYPE_BON_RECEPTION,
  SOUS_TYPE_AVOIR_SUR_ACOMPTE,
} from '@/configuration/devisConf';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { TIERS_TYPE_CLIENT } from '@/configuration/tiers/tiersConf';
import messageErreur from '@/services/general/messageErreur';
import acomptesAffectes from '@/components/devisCommandes/detailDevisCommande/acomptesAffectes';
import RepartitionsTva from '@/components/devisCommandes/detailDevisCommande/repartitionsTva';
import InfosIntervenant from '@/components/devisCommandes/detailDevisCommande/infosIntervenant';
import DetailLignesCommande from '@/components/devisCommandes/detailDevisCommande/detailLignesCommande';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import logoSociete from '@/components/general/logoSociete';
import InfosCommercial from '@/components/devisCommandes/detailDevisCommande/infosCommercial';
import logoAgence from '@/components/general/logoAgence';
import { pGetAllPieceJointe } from '@/api/pieceJointes';
import { PIECE_JOINTE_TYPE_LOGO_FACTURE } from '@/configuration/general/pieceJointeConf';
import { CATEGORIE_OPERATION } from '@/configuration/catalogue/produitConf';
import lignesNormalesGetter from '@/services/devisCommandes/lignesNormalesGetter';
import multiContactIntervenant from '@/components/devisCommandeFacture/multicontact/multiContactIntervenant';
import { get as getTiers } from '@/api/tiers/index';
import { MODULE_TLPE } from '@/configuration/gabed/titreRecette/titreRecetteConf';
import getExonerationTva from '@/services/tiers/getExonerationTva';
import { TYPE_REFERENCE_EXTERNE_VENTE } from '@/configuration/dcf/dcfConf';
import { getAll } from '@/api/commande';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    facture: {
      type: Object,
      required: true,
    },
    factureDetail: {
      type: Object,
      required: true,
    },
    isEditPrevisu: {
      type: Boolean,
      required: false,
    },
    isPrevisualisation: {
      type: Boolean,
      required: false,
    },
    isEdit: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      constantes: {
        REFERENCE_EXTERNE_CONTRAT,
        TYPE_FACTURE,
        SOUS_TYPE_AVOIR,
        SOUS_TYPE_AVOIR_SUR_ACOMPTE,
      },
      logo: null,
      func: { getExonerationTva },
      commandeVenteCode: null,
    };
  },
  components: {
    RecapitulatifMontants,
    acomptesAffectes,
    RepartitionsTva,
    DetailLignesCommande,
    InfosIntervenant,
    routerLinkBlank,
    logoSociete,
    InfosCommercial,
    logoAgence,
    multiContactIntervenant,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      logoAgences: 'logoAgences',
      societeActiveId: 'societeActiveId',
    }),
    getFactureRoute() {
      if (this.isFactureAvoir && this.factureDetail.aRapprocher) {
        if (this.factureDetail.module === MODULE_TLPE) {
          return 'c.gabed.titre_recette';
        }
        return 'c.baux.facture_achat';
      }
      return 'c.bodac.factures';
    },
    reglesFacturation() {
      return this.parametre(PARAMETRES_KEYS.regleFacturation);
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    moduleCampagneActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.campagne.key);
    },
    modulePlanMediaActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePlanMedia.key);
    },
    champObligatoireFactureActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.champObligatoireFacture.key);
    },
    tvaIntracommunautaireVisible() {
      const destinataireTva = this.facture.destinataire?.tvaIntracommunautaire;
      const tiersTva = this.facture.destinataire?.tiers?.tvaIntracommunautaire;

      return !!destinataireTva || (!this.champObligatoireFactureActive && !!tiersTva);
    },
    tvaIntracommunautaireValue() {
      if (this.facture.destinataire?.tvaIntracommunautaire) {
        return this.facture.destinataire.tvaIntracommunautaire;
      }
      if (!this.champObligatoireFactureActive) {
        return this.facture.destinataire?.tiers?.tvaIntracommunautaire;
      }
      return null;
    },
    siretVisible() {
      const destinataireSiret = this.facture.destinataire?.siret;
      const tiersSiret = this.facture.destinataire?.tiers?.siret;

      return !!destinataireSiret || (!this.champObligatoireFactureActive && !!tiersSiret);
    },
    siretLabel() {
      if (this.facture.destinataire?.siret || this.champObligatoireFactureActive) {
        return this.$t('detailFacture.clients.siretClient', { siret: this.facture.destinataire.siret });
      }
      if (this.facture.destinataire?.tiers?.siret && !this.champObligatoireFactureActive) {
        return this.$t('detailFacture.clients.siretClient', { siret: this.facture.destinataire.tiers.siret });
      }
      return this.$t('detailFacture.clients.siretDefault');
    },
    isFactureAvoir() {
      return this.factureDetail.type === TYPE_FACTURE
        && [SOUS_TYPE_AVOIR, SOUS_TYPE_AVOIR_SUR_ACOMPTE].includes(this.factureDetail.sousType);
    },
    isFactureNormal() {
      return this.factureDetail.type === TYPE_FACTURE
        && this.factureDetail.sousType === SOUS_TYPE_NORMAL;
    },
    isFactureAnnule() {
      return this.factureDetail.type === TYPE_FACTURE
        && this.factureDetail.etat === ETAT_ANNULER
        && this.factureDetail.sousType === SOUS_TYPE_NORMAL;
    },
    isFactureBailleur() {
      return this.factureDetail.typeReferenceExterne === REFERENCE_EXTERNE_CONTRAT
        && this.factureDetail.sens === SENS_ACHAT;
    },
    isAnnulationPaiement() {
      return this.factureDetail.typeReferenceExterne === ANNULATION_REGLEMENT
        && this.factureDetail.sens === SENS_VENTE;
    },
    remiseBancaireId() {
      if (!this.isAnnulationPaiement) return null;
      return this.factureDetail.referenceExterne.split('|')[2];
    },
    isSensAchat() {
      return this.factureDetail.sens === SENS_ACHAT;
    },
    activeButtonEtLien() {
      return this.checkIfCurrentSociety(this.factureDetail.societeId);
    },
    commercial() {
      if (this.facture.generalInfos && this.facture.generalInfos.commercial
        && this.facture.generalInfos.commercial.nom) return this.facture.generalInfos.commercial;
      return null;
    },
    getlibelleToDisplay() {
      if (this.isFactureBailleur) return this.$t('detail.generalInfos.dateEcheance');
      return this.$t('detail.generalInfos.datePremierAffichage');
    },
    mentionMandataire() {
      return (this.parametresInterne(PARAMETRES_INTERNE_KEYS.mentionMandataire.key)
        && this.facture.destinataire.mandataire);
    },
    logoParAgence() {
      return (this.parametresInterne(PARAMETRES_INTERNE_KEYS.logoParAgence.key)
        && !this.isSensAchat);
    },
    getCatgorieOperation() {
      const lignes = lignesNormalesGetter(this.factureDetail);
      let categories = lignes.filter(l => {
        return l.produit && l.produit.categorieOperation;
      }).map(l => {
        return l.produit.categorieOperation;
      });
      categories = [...new Set(categories)];
      if (categories.length === 0) return this.$t('catalogue.categorieOperation.default');
      if (categories.length > 1) return this.$t('catalogue.categorieOperation.both');
      return this.getLibelleCategorieOperation(categories[0]);
    },
    isCommandeOrFactureAchatFournisseur() {
      return this.factureDetail.module === MODULE_ACHAT
        && this.factureDetail.sens === SENS_ACHAT
        && [TYPE_COMMANDE, TYPE_FACTURE].includes(this.factureDetail.type);
    },
    isBonReception() {
      return this.factureDetail.module === MODULE_ACHAT
        && this.factureDetail.sens === SENS_ACHAT
        && this.factureDetail.type === TYPE_COMMANDE
        && this.factureDetail.sousType === SOUS_TYPE_BON_RECEPTION;
    },
    routeTiers() {
      const { tiers, adressePostale, nomCommercial } = this.facture?.destinataire || {};
      let name = 'c.bodac.clients/contacts-client';
      const message = adressePostale?.intitule1 ?? nomCommercial;
      if (this.isSensAchat) {
        name = 'c.baux.bailleur';
        if (this.factureDetail.module === MODULE_TLPE) {
          name = 'c.gabed.collectivite';
        }
      }
      if (tiers && this.isCommandeOrFactureAchatFournisseur) {
        name = tiers.type === TIERS_TYPE_CLIENT
          ? 'c.bodac.clients/contacts-client'
          : 'c.achat.fournisseurs';
      }
      return {
        to: { name: name, params: { id: tiers?.id } },
        message: message,
      };
    },
    canDisplayDestinataireComptableLabel() {
      return this.facture.destinataire?.destinataireComptable === true
        && this.factureDetail.sens === SENS_VENTE
        && this.factureDetail.type === TYPE_FACTURE;
    },
    isCommandeAchatFournisseur() {
      return this.factureDetail.module === MODULE_ACHAT
        && this.factureDetail.sens === SENS_ACHAT
        && this.factureDetail.type === TYPE_COMMANDE;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
      loadParametres: 'loadParametres',
    }),
    getLibelleRegleFacturation(regleId) {
      const regleFind = this.reglesFacturation.find((regle) => {
        return regle.id === regleId;
      });
      return regleFind ? regleFind.libelle : null;
    },
    getLibelleCategorieOperation(categorieOp) {
      const find = CATEGORIE_OPERATION.find((categorie) => {
        return categorie.code === categorieOp;
      });
      return find ? this.$t(find.libelle) : '';
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.mentionMandataire.key,
        PARAMETRES_INTERNE_KEYS.modulePresse.key,
        PARAMETRES_INTERNE_KEYS.modulePlanMedia.key,
        PARAMETRES_INTERNE_KEYS.champObligatoireFacture.key,
        PARAMETRES_INTERNE_KEYS.campagne.key]);
      await this.loadParametres([PARAMETRES_KEYS.regleFacturation]);
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.logoParAgence.key]);
      if (this.factureDetail.agenceId) {
        const logoAgence = this.logoAgences.find(logo => {
          return logo.elementId === this.factureDetail.agenceId;
        });
        this.logo = logoAgence ? (logoAgence.cheminMin || logoAgence.chemin) : null;
      }
      if (this.factureDetail.regleFacturationId) {
        const logoFacture = (await pGetAllPieceJointe({
          elementsId: [this.factureDetail.regleFacturationId],
        })).data.result.items.find(p => p.type.libelle === PIECE_JOINTE_TYPE_LOGO_FACTURE);
        this.logo = logoFacture ? (logoFacture.cheminMin || logoFacture.chemin) : null;
      }
      if (!this.facture.destinataire.tiers) {
        const tiers = await getTiers(this.facture.destinataire.tiersId);
        this.$set(this.facture.destinataire, 'tiers', tiers.data.result);
      }
      if (!!this.factureDetail.referenceExterne
        && this.factureDetail.typeReferenceExterne === TYPE_REFERENCE_EXTERNE_VENTE) {
        this.isFetchingCommande = true;
        const commande = (await getAll({
          query: {
            ids: [this.factureDetail.referenceExterne],
            societeId: this.societeActiveId,
            sousType: [SOUS_TYPE_NORMAL],
            type: TYPE_COMMANDE,
            sens: SENS_VENTE,
          },
        })).data.result.items;
        this.commandeVenteCode = commande.pop().code;
      }
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};

</script>
